export default "__VITE_ASSET__25b91d91__"